import React, { useState } from 'react';
import AddCardModal from '../../pages/Dashboard/Company/Employees/Modal/AddCardModal';
import {AddIcon} from "./IconButtons";
import ButtonAction from "./ButtonAction";

const CreateCardBtn = (props) => {
    const [addCustomizedDialogShow, setAddCustomizedDialogShow] = useState(false);

    const handleCard = () => {
        setAddCustomizedDialogShow(true);
    };
    return (
        <div>
            <ButtonAction
                id={"btn_ccb_create"}
                name={"create"}
                className={"btn-icon-add"}
                onClick={handleCard}
                Icon={AddIcon}
            />

            {addCustomizedDialogShow &&
                <AddCardModal
                    {...props}
                    open={addCustomizedDialogShow}
                    onHide={() => {
                        setAddCustomizedDialogShow(false);
                    }}
                />
            }
        </div>
    );
};

export default CreateCardBtn;
